import { Box, Card, styled } from "@mui/material";
import React, { useState } from "react";
//   import useAuth from '../../../hooks/useAuth';
import useAuth from "./../../hooks/useAuth";
import { useGetAllUser, useUserLogs, useDeleteLogs } from "../../requests/user";
import moment from "moment";

import { Button, Table, Popover, DatePicker, Select, Popconfirm, message } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import { ImInfo } from "react-icons/im";
import { Link } from "react-router-dom";
import { useQueryClient } from "react-query";
import { route } from "../../requests/routes";

const CardHeader = styled(Box)(() => ({
  display: "flex",
  paddingLeft: "24px",
  paddingRight: "24px",
  marginBottom: "12px",
  alignItems: "center",
  justifyContent: "space-between",
}));

const Title = styled("span")(() => ({
  fontSize: "1rem",
  fontWeight: "500",
  textTransform: "capitalize",
}));

const ActivityLogs = ({ isDashboard = false }) => {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [eventType, setEventType] = useState(null);
  const [admin_id, setAdmin_id] = useState(null);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const { data: logData, isLoading } = useUserLogs({ page, pageSize, startDate, endDate, eventType, admin_id });
  const { data: users } = useGetAllUser();
  const { mutateAsync: deleteLogs, isLoading: isDeleting } = useDeleteLogs();
  const queryClient = useQueryClient();

  async function handleDeleteLogs(ids) {
    try {
      await deleteLogs(ids);
      message.success(ids.length > 1 ? `${ids.length} logs deleted` : "Log deleted");
      setSelectedRowKeys((prev) => prev.filter((id) => !ids.includes(id)));
      queryClient.invalidateQueries([route.ALL_lOGS]);
    } catch (error) {
      message.error(error?.response?.data?.message ?? "Something wrong on server");
    }
  }

  function getAdminUserListOptions() {
    if (!users) {
      return [];
    }
    let options = users.map((x) => ({ label: x?.email, value: x?.id }));
    return [{ label: "All", value: null }, ...options];
  }

  const user = useAuth();
  if (user?.user?.service_area_id) {
    return <></>;
  }

  // role 0 is the owner/super-admin role (same convention as checkRoleExist /
  // checkWriteRole in utils.js) — only the owner sees this audit trail.
  if (user?.user?.role !== 0) {
    return <></>;
  }

  function LogDetail(detail, row) {
    const { eventType } = row;
    if (eventType === "Product-Add" || eventType === "Product-Update") {
      return (
        <>
          <ul>
            {detail?.status && <li>Event : Product Status Changed</li>}

            {detail?.title && <li>Title:{detail?.title}</li>}

            {detail?.status && <li>status :{detail?.status}</li>}

            <li>
              <a target="_blank" href={`/product/detail/${detail?.productId}`}>
                View Product
              </a>
            </li>
          </ul>
        </>
      );
    }

    if (eventType === "User-Login") {
      return (
        <>
          <ul>
            <li>
              Country: <b>{detail?.country}</b>
            </li>
            <li>
              Region: <b>{detail?.region}</b>{" "}
            </li>
            <li>
              city: <b>{detail?.city}</b>{" "}
            </li>
            <li>
              Post Code: <b>{detail?.postal}</b>{" "}
            </li>
            <li>
              ISP: <b>{detail?.org}</b>{" "}
            </li>
            <li>
              Location :{" "}
              <a target="_blank" href={`https://www.google.com/maps?q=${detail?.loc}`}>
                {" "}
                <b>View</b>{" "}
              </a>
            </li>
            <li>
              IP :{" "}
              <a href={`https://ipinfo.io/${detail?.ip}/json`}>
                {" "}
                <b>{detail?.ip}</b>{" "}
              </a>
            </li>
          </ul>
        </>
      );
    }

    if (eventType === "CampaignProduct-Add") {
      return (
        <>
          <ul>
            <li>
              Campaign: <b> {detail?.campaign ?? ""} </b>
            </li>
            {detail?.productId && (
              <li>
                Product:{" "}
                <a target="_blank" href={`/product/detail/${detail?.productId}`}>
                  {" "}
                  <b>View</b>{" "}
                </a>{" "}
              </li>
            )}
          </ul>
        </>
      );
    }
    if (eventType === "CampaignProduct-Delete") {
      return (
        <>
          <ul>
            <li>
              Campaign: <b> {detail?.campaign ?? ""} </b>
            </li>
            {detail?.productId && (
              <li>
                Product:{" "}
                <a target="_blank" href={`/product/detail/${detail?.productId}`}>
                  {" "}
                  <b>View</b>{" "}
                </a>{" "}
              </li>
            )}
          </ul>
        </>
      );
    }

    return (
      <>
        <ul>
          {String(JSON.stringify(detail))
            .split(",")
            .map((x) => (
              <li>{String(x)}</li>
            ))}
        </ul>
      </>
    );
  }

  const columns = [
    {
      title: "Time",
      dataIndex: "timestamp",
      key: "timestamp",
      render: (timestamp) => (timestamp ? moment(timestamp).format("DD/MM hh:mm:ss A") : "-"),
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
    },
    {
      title: "User",
      dataIndex: "admin",
      key: "admin",
      render: (admin) => admin?.email ?? "-",
    },
    {
      title: "Detail",
      dataIndex: "details",
      key: "details",
      render: (detail, row) => (
        <Popover content={LogDetail(detail, row)} title="Details" trigger="hover">
          <Button icon={<ImInfo />}></Button>
        </Popover>
      ),
    },
    ...(isDashboard
      ? []
      : [
          {
            title: "Manage",
            key: "manage",
            render: (_, row) => (
              <Popconfirm
                title="Are you sure you want to delete this log?"
                onConfirm={() => handleDeleteLogs([row.id])}
              >
                <Button danger icon={<DeleteOutlined />} loading={isDeleting} />
              </Popconfirm>
            ),
          },
        ]),
  ];

  return (
    <Card elevation={3} sx={{ pt: "20px", mb: 3, margin: 1 }}>
      <CardHeader>
        <Title>Activity Logs</Title>
        {isDashboard ? (
          <>
            <Link to={"/dashboard/logs"}>
              <Button onClick={(e) => {}}>See all</Button>
            </Link>
          </>
        ) : (
          <div style={{ display: "flex", justifyContent: "right", flexWrap: "wrap" }}>
            <Select
              onChange={(e) => {
                setAdmin_id(e);
              }}
              style={{ minWidth: 200 }}
              placeholder="Choose user"
              options={getAdminUserListOptions()}
            />
            <DatePicker.RangePicker
              size="small"
              onChange={(e) => {
                if (e) {
                  setStartDate(e[0].$d);
                  setEndDate(e[1].$d);
                } else {
                  setStartDate(null);
                  setEndDate(null);
                }
              }}
            />
            {selectedRowKeys.length > 0 && (
              <Popconfirm
                title={`Are you sure you want to delete ${selectedRowKeys.length} selected log(s)?`}
                onConfirm={() => handleDeleteLogs(selectedRowKeys)}
              >
                <Button danger icon={<DeleteOutlined />} loading={isDeleting} style={{ marginLeft: 8 }}>
                  Delete Selected ({selectedRowKeys.length})
                </Button>
              </Popconfirm>
            )}
          </div>
        )}
      </CardHeader>

      <Box overflow="auto">
        <Table
          size="small"
          rowKey="id"
          dataSource={logData?.logs ?? []}
          rowSelection={
            isDashboard
              ? undefined
              : {
                  selectedRowKeys,
                  onChange: (keys) => setSelectedRowKeys(keys),
                }
          }
          pagination={{
            size: "small",
            total: logData?.totalCount,
            current: page,
            onChange: (e, d) => {
              setPage(e);
              setPageSize(d);
            },
          }}
          loading={isLoading}
          columns={columns}
        />
        ;
      </Box>
    </Card>
  );
};

export default ActivityLogs;
